export const avatarFallback = (img) => {
	if (
		typeof img.src === 'string' &&
		img.src.length &&
		img.src.includes('rackcdn.com/photos/')
	) {
		img.src = 'https://resources.bamboohr.com/images/photo_person_150x150.png';
	}
};
